<template>
    <div class="portlet light bordered">
      <form v-on:submit.prevent="validar">
        <div class="portlet-title tabbable-line">
            <div class="caption">
                <span class="caption-subject font-dark bold uppercase">Parámetros</span>
            </div>
        </div>

        <div class="portlet-body">
            <div class="tab-content">
                <div class="tab-pane active">
                        <fieldset :disabled="cargando">
                            <div class="form-group">
                                <label>Zoom Link</label>
                                <input type="url" v-model="formulario.zoom" class="form-control" placeholder="https://zoom.us/">
                            </div>
                            <div class="row">
                              <div class="col-md-6 form-group">
                                <label>Promedio</label>
                                <input type="number" v-model="formulario.promedio" class="form-control" >
                              </div>
                              <div class="col-md-6 form-group">
                                <label>Espera</label>
                                <input type="number" v-model="formulario.espera" class="form-control" >
                              </div>
                            </div>
                        </fieldset>

                </div>
            </div>
        </div>
        <br><br>
        <div class="portlet-title tabbable-line">
          <div class="caption">
            <span class="caption-subject font-dark bold uppercase">Parámetros Globales</span>
          </div>
        </div>

        <div class="portlet-body">
          <div class="tab-content">
            <div class="tab-pane active">
              <fieldset :disabled="cargando">
                <div class="form-group">
                  <label>Enlace de redireccion</label>
                  <input type="text" v-model="formulario.urlRedireccion" class="form-control" placeholder="">
                </div>
                <label class="m-checkbox m-checkbox--focus">
                  <input type="checkbox" name="remember" v-model="formulario.habilitarRedireccion">
                  Habilitar redireccion
                  <span></span>
                </label>
                <div></div>
                <br>
                <button type="submit" class="btn btn-primary">Actualizar</button>
              </fieldset>

            </div>
          </div>
        </div>


      </form>
    </div>
</template>

<script>
    export default {
        name: "zoom",
        data:()=>({
            cargando:false,
            formulario:{
                cubiculo:null,
                zoom:null,
                promedio:null,
                habilitarRedireccion: null,
                urlRedireccion:  null
            }
        }),
        methods:{
            validar:function(){
                this.cargando=true;
                this.enviarDatos();
            },
            cargar:function(){
                this.cargando=true;
                axios.get("/app/todo-configuracion")
                    .then((response) => {
                        this.cargando=false;
                        this.formulario.zoom=response.data.cubiculo.link_cu;
                        this.formulario.promedio=response.data.cubiculo.promedio;
                        this.formulario.espera=response.data.cubiculo.espera;
                        this.formulario.urlRedireccion=response.data.urlRedireccion.valor;
                        if(response.data.habilitarRedireccion.valor === '1'){
                          this.formulario.habilitarRedireccion=response.data.habilitarRedireccion.valor;
                        }
                    }).catch(()=>{
                    this.cargando=false;
                });
            },
            enviarDatos: _.debounce(function () {
                axios.post("/app/configuracion",this.formulario)
                    .then((response) => {
                        if(response.data.val){
                            toastr.success(response.data.mensaje);
                        }else{
                            toastr.error(response.data.mensaje);
                        }
                        this.cargando=false;
                    }).catch(()=>{
                        this.cargando=false;
                });
            }, 500),
        },
        created() {
            this.cargar();
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/operador/zoom.vue